import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
function AttributionEntries({ children, attributions, }) {
    return (_jsx("div", { className: "ms3-attribution", children: _jsxs("ul", { className: "ms3-attribution__entries", children: [attributions &&
                    Object.entries(attributions).map(([key, attr]) => (_jsx("li", { className: "ms3-attribution__entry", dangerouslySetInnerHTML: { __html: attr } }, key))), children && (_jsx("li", { className: "ms3-attribution__entry ms3-attribution__entry--additional", children: children }))] }) }));
}
export default memo(AttributionEntries);
